'use client'

import { useEffect, useRef } from 'react'
import { signOut } from 'next-auth/react'
import { clearApiToken } from '@/libs/api'
import { clearSessionActivity } from '@/libs/session-idle'
import { redirectAllTabsToLogin, subscribeLogoutBroadcast } from '@/libs/auth-cross-tab'

/**
 * Listens for logout in other tabs and forces this tab to clear session + refresh to login.
 */
const AuthCrossTabSync = () => {
  const handlingRef = useRef(false)

  useEffect(() => {
    return subscribeLogoutBroadcast(async () => {
      if (handlingRef.current) return
      if (globalThis.location.pathname.includes('/login')) return
      handlingRef.current = true

      try {
        clearApiToken()
        clearSessionActivity()
        try {
          sessionStorage.removeItem('app_initialized')
        } catch {
          // ignore
        }
        await signOut({ redirect: false })
      } catch {
        // still force navigation
      } finally {
        redirectAllTabsToLogin()
      }
    })
  }, [])

  return null
}

export default AuthCrossTabSync
